import * as XLSX from 'xlsx';

/**
 * Count data rows in an XLS template. The server-side parser uses a
 * 3-row header (data_start_row = 3), so the first data row is XLS row 3.
 *
 * We count rows that have at least one non-empty cell to mirror the
 * server's `hasAnyData` filter — but we exclude the `udi` column
 * specifically since it's auto-filled by SEQUENCE() and would
 * otherwise count as data.
 *
 * Returns null if the file cannot be parsed.
 */
export async function countXlsDataRows(file: File): Promise<number | null> {
    try {
        const buf = await file.arrayBuffer();
        const wb = XLSX.read(buf, { type: 'array' });
        const sheet = wb.Sheets[wb.SheetNames[0]];
        if (!sheet) return null;

        const aoa = XLSX.utils.sheet_to_json<unknown[]>(sheet, { header: 1, blankrows: false }) as unknown[][];

        // Skip first 2 header rows. Count rows with non-empty cells.
        let count = 0;
        for (let i = 2; i < aoa.length; i++) {
            const row = aoa[i] || [];
            for (let j = 0; j < row.length; j++) {
                const cell = row[j];
                if (cell !== undefined && cell !== null && String(cell).trim() !== '') {
                    count++;
                    break;
                }
            }
        }
        return count;
    } catch (e) {
        return null;
    }
}
